import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { RouteEnum } from 'modules/account/constantes/RouteEnum';

export const useBackgroundByRoute = () => {
  const location = useLocation();
  const theme = ApiLocalStorage.get('theme') || {};

  useEffect(() => {
    const isWelcomePage = location.pathname === RouteEnum.WELCOME;
    
    if (isWelcomePage && theme.welcome) {
      // Aplicar background específico da página welcome
      const welcomeBackground = theme.welcome.background;
      const welcomeBackgroundMobile = theme.welcome.backgroundMobile;
      
      document.body.style.background = welcomeBackground;
      
      // Aplicar background mobile se estiver em dispositivo móvel
      if (window.innerWidth <= 768 && welcomeBackgroundMobile) {
        document.body.style.background = welcomeBackgroundMobile;
      }
    } else {
      // Aplicar background padrão (cor detached)
      document.body.style.background = theme.designTokens?.['color-background'];
      
      // Aplicar background mobile se estiver em dispositivo móvel
      if (window.innerWidth <= 768) {
        document.body.style.background = theme.designTokens?.['color-background-mobile'];
      }
    }

    // Listener para mudanças de tamanho da tela
    const handleResize = () => {
      if (isWelcomePage && theme.welcome) {
        if (window.innerWidth <= 768 && theme.welcome.backgroundMobile) {
          document.body.style.background = theme.welcome.backgroundMobile;
        } else {
          document.body.style.background = theme.welcome.background;
        }
      } else {
        if (window.innerWidth <= 768) {
          document.body.style.background = theme.designTokens?.['color-background-mobile'];
        } else {
          document.body.style.background = theme.designTokens?.['color-background'];
        }
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname, theme]);
}; 